/*global IntersectionObserver */

export default class {
	constructor(block) {
		this.nav = block.querySelector(".locations-nav");

		if (!this.nav) {
			return;
		}

		const navItems = this.nav.querySelectorAll(".location-nav-item");

		for (const navItem of navItems) {
			navItem.addEventListener("click", this.selectItem.bind(this));
		}

		const observer = new IntersectionObserver(this.toggleActiveItem.bind(this));
		observer.observe(this.nav);
	}

	selectItem(e) {
		if (e.target.classList.contains("active")) {
			return;
		}

		this.nav.querySelector(".active").classList.remove("active");
		e.target.classList.add("active");
	}

	toggleActiveItem(entries) {
		if (entries[0].isIntersecting) {
			this.nav.querySelector(".active").classList.remove("active");
			this.nav.querySelector(".location-nav-item").classList.add("active");
		}
	}
}
